import { downloadUrl } from './download-url';

export const downloadFile = (blob: Blob, fileName: string) => {
    const url = URL.createObjectURL(blob);
    downloadUrl(url, fileName);
};
